"use client";

import type { MutableRefObject, RefObject } from "react";
import { useEffect, useRef } from "react";
import {
  type ApplyZoomAtAnchorParams,
  type PinchState,
} from "./gantt-zoom-control-math";
import { createGanttZoomPointerListeners } from "./gantt-zoom-pointer-listeners";

interface UseGanttZoomPointerListenersParams {
  applyZoomAtAnchor: (params: ApplyZoomAtAnchorParams) => void;
  fitPxPerDayRef: MutableRefObject<number>;
  isEnabled: boolean;
  pxPerDayOverrideRef: MutableRefObject<number | null>;
  timelineScrollRef: RefObject<HTMLDivElement | null>;
}

export function useGanttZoomPointerListeners({
  applyZoomAtAnchor,
  fitPxPerDayRef,
  isEnabled,
  pxPerDayOverrideRef,
  timelineScrollRef,
}: UseGanttZoomPointerListenersParams): void {
  const pinchStateRef = useRef<PinchState | null>(null);

  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    const timelineNode = timelineScrollRef.current;
    if (!timelineNode) {
      return undefined;
    }

    return createGanttZoomPointerListeners({
      applyZoomAtAnchor,
      fitPxPerDayRef,
      pinchStateRef,
      pxPerDayOverrideRef,
      timelineNode,
    });
  }, [
    applyZoomAtAnchor,
    fitPxPerDayRef,
    isEnabled,
    pxPerDayOverrideRef,
    timelineScrollRef,
  ]);
}
